import service from '@/store/services/notification-service';

const state = {
    notificationList: [],
};

const mutations = {
    SET_NOTIFICATION_LIST: (state, notifications) => {
        state.notificationList = notifications;
    },
    MARK_NOTIFICATION_AS_READ: (state, notification_id) => {
        state.notificationList[state.notificationList.findIndex(({ notifications_list_id }) => notifications_list_id === notification_id)].read = true;
    },
};

const actions = {
    getNotificationList({ commit, state }, params) {
        if (params.user_id) {
            let currentSession = localStorage.getItem(
                'vue-authenticate.vueauth_access_token'
            );
            return service
                .notificationList({
                    session_id: currentSession,
                    user_id: params.user_id,
                })
                .then((res) => {
                    if (res.hasOwnProperty('data') && res.data.error) {
                        commit('SET_ERROR_BIT', true, { root: true });
                        commit(
                            'SET_ERROR_INFO',
                            '<br>' +
                            'Server responded with error = True <br> errorCode: ' +
                            res.data.errorCode, { root: true }
                        );
                        state.notificationList = [];
                    }
                    else {
                        state.notificationList = res.data?.results ?? [];
                    }
                })
        }
    },

    showNotification({ commit, rootGetters }, params) {
        if (rootGetters['user/user_id']) {
            let currentSession = localStorage.getItem(
                'vue-authenticate.vueauth_access_token'
            );
            return service
                .notificationDetails({
                    session_id: currentSession,
                    ip_address: localStorage.getItem('userIP'),
                    user_id: rootGetters['user/user_id'],
                    notification_id: params.notification_id,
                    date_read: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} ` + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds()
                })
                .then((res) => {
                    if (res.hasOwnProperty('data') && res.data.error) {
                        commit('SET_ERROR_BIT', true, { root: true });
                        commit(
                            'SET_ERROR_INFO',
                            '<br>' +
                            'Server responded with error = True <br> errorCode: ' +
                            res.data.errorCode, { root: true }
                        );
                    }
                    else {
                        commit(
                            "SET_GENERIC_MODAL",
                            res.data?.results?.message ?? ''
                        );
                        commit('MARK_NOTIFICATION_AS_READ', params.notification_id);
                    }
                })
        }
    },

    trackView({ commit, rootGetters, state }) {
        if (rootGetters['user/user_id']) {
            let currentSession = localStorage.getItem(
                'vue-authenticate.vueauth_access_token'
            );
            return service
                .trackView({
                    session_id: currentSession,
                    ip_address: localStorage.getItem('userIP'),
                    user_id: rootGetters['user/user_id'],
                    notification_id: state.notificationList.filter(x => !x.read).map((obj) => obj.notifications_list_id),
                    date_read: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} ` + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds()
                })
                .then((res) => {
                    if (res.hasOwnProperty('data') && res.data.error) {
                        commit('SET_ERROR_BIT', true, { root: true });
                        commit(
                            'SET_ERROR_INFO',
                            '<br>' +
                            'Server responded with error = True <br> errorCode: ' +
                            res.data.errorCode, { root: true }
                        );
                    }
                   
                })
        }
    },
};

const getters = {
    notificationList: (state) => state.notificationList,
    countNewNotification: (state) => state.notificationList.filter(x => !x.read),
};

const notification = {
    state,
    mutations,
    actions,
    getters,
};

export default notification;
